<template>
    <el-drawer
        title="新增原因"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="500px"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                label-position="top"
                size="medium"
            >   
				<el-form-item  v-if="type == 0 ">                    
					<div class="color-warning">发货前 - 申请取消商品：发货前用户才能选择该售后类型</div>
                </el-form-item>
				<el-form-item  v-if="type == 1 ">
					<div class="color-warning">发货后 - 申请退货：发货后用户才能选择该售后类型</div>
				</el-form-item> 
                <el-form-item prop="reason" label="原因:">                    
					<el-input v-model.trim="formData.reason" type="textarea" :rows="2" maxlength="40" show-word-limit ></el-input>
                </el-form-item>
				<el-form-item prop="isPhoto">
				    <span slot="label">上传照片: </span>
				    <el-radio-group v-model="formData.isPhoto">
				        <el-radio :label="1" border>必须上传</el-radio>
				        <el-radio :label="0" border>选择上传</el-radio>
				    </el-radio-group>                    
				</el-form-item>
				
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>

const defaultData = {
    isPhoto:1,
    reason:'',
	status:1,
	sort:0
}
export default {
	props:{
	    activeName:{
	        type: String,
	        default: null
	    }
	},
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formData:{
                ...defaultData
            },
            rules:{
                reason:[{ required: true, message: "请填写原因", trigger:"blur" }],
				isPhoto:[{ required: true, message: "请选择是否上传照片", trigger:"blur" }],
            },
			type:''
        }
    },
    methods:{
        close(){
            this.$refs.formData.resetFields();
            this.drawerShow = false;            
            this.formData = {
                ...defaultData
            }
        },
        show(type){
			this.type = type
            this.drawerShow = true;			
        },
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/goodsAfterSale/reason/save',
                        data: {
							...this.formData,
                            type:this.type                          
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
								if( this.type == 0 ){
									this.$emit( "callBack",1 )									
									this.$emit('onUpdate',0);									
								}else{
									this.$emit( "callBack",2 )
									this.$emit('onUpdate',1);									
								}						
                               this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>